import { withInstall } from "../utils/index.mjs";
import _Row from "./Row.mjs";
const Row = withInstall(_Row);
var stdin_default = Row;
import { rowProps } from "./Row.mjs";
export {
  Row,
  stdin_default as default,
  rowProps
};
